/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import Button from 'components/base/Button';
import LabelInput from 'components/custom/forms/LabelInput';
import { AuthContext } from 'context/AuthContext';
import { useAlert } from 'providers/AlertModalProvider';
import { useModal } from 'providers/ConfirmationModalProvider';
import { useContext } from 'react';
import postData from 'services/postData';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const ApprovalMessage = ({
  handleClose,
  type,
  challanNo,
  handleOnConfirm,
  name
}) => {
  const formik = useFormik({
    initialValues: {
      last_comment: ''
    },
    validationSchema: Yup.object({
      last_comment: Yup.string().when('type', {
        is: () => type !== 'verify',
        then: () => Yup.string().required('Comment is required')
      })
    }),
    onSubmit: values => {
      handleOnConfirm(values.last_comment);
      handleClose();
    }
  });
  return (
    <div>
      <p>
        You are about to {type === 'verify' ? 'verify' : 'decline'} the
        {' ' + name}.
      </p>
      {/* Textarea for Note */}
      {type !== 'verify' && (
        <div className="d-flex flex-column text-start justify-content-start mb-4 px-6">
          <div className="mb-1">
            <LabelInput
              label={'Comment'}
              required={type !== 'verify'}
              controlId={'last_comment'}
              formik={formik}
              placeholder={'Add a comment'}
              inputProps={{ as: 'textarea' }}
              errorProps={{ tooltip: false }}
            />
          </div>
          <small className="text-warning fw-light">
            Note: This action cannot be reversed.
          </small>
        </div>
      )}
      <div className="border-0 gap-2 d-flex justify-content-center mb-2">
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant={type === 'verify' ? 'info' : 'danger'}
          onClick={formik.handleSubmit}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

const useConfirmationModal = (endPoint, name) => {
  const { showAlert } = useAlert();
  const { showConfirmation } = useModal();
  const { user } = useContext(AuthContext);

  const onConfirm = async (
    handleLoading,
    type,
    payLoad,
    handleRefresh,
    last_comment
  ) => {
    // Add your disable logic here
    handleLoading(
      true,
      type === 'verify' ? `Verify ${name}` : `Decline ${name}`
    );
    const requestStatus = await postData(
      {
        checked_by: user.user_id,
        is_checked: type === 'verify' ? '1' : '2',
        last_comment,
        ...payLoad
      },
      endPoint,
      { requestBodyMethod: 'POST' }
    );
    if (requestStatus.status) {
      handleLoading(false);
      handleRefresh();

      showAlert({
        variant: 'success',
        message: `The checking of ${name} has been successfully ${type === 'verify' ? 'verified' : 'declined'}.`
      });
    } else {
      handleLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to ${type === 'verify' ? 'verifying' : 'decline'} the ${name} ". Please try again later.`
      });
    }
  };

  const handleApproval = async (
    challanNo,
    payLoad,
    handleLoading,
    handleRefresh,
    type
  ) => {
    showConfirmation({
      message: handleClose => (
        <ApprovalMessage
          type={type}
          handleClose={handleClose}
          challanNo={challanNo}
          handleOnConfirm={comment =>
            onConfirm(handleLoading, type, payLoad, handleRefresh, comment)
          }
          name={name}
        />
      ),
      severity: type === 'verify' ? 'info' : 'danger',
      confirmBtn: 'Yes',
      showFooter: false
    });
  };

  const acceptCheck = async (
    challanNo,
    payLoad,
    handleLoading,
    handleRefresh
  ) => {
    await handleApproval(
      challanNo,
      payLoad,
      handleLoading,
      handleRefresh,
      'verify'
    );
  };

  const rejectCheck = async (
    challanNo,
    payLoad,
    handleLoading,
    handleRefresh
  ) => {
    await handleApproval(
      challanNo,
      payLoad,
      handleLoading,
      handleRefresh,
      'decline'
    );
  };

  return { acceptCheck, rejectCheck };
};

export default useConfirmationModal;
